import { Button, Image, Typography } from '@smartgift/frontend-toolkit';
import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { UPLOAD_LOGO_SCREEN } from './constants';
import { UploadLogoContext } from './context';
import * as S from './style';
import { b64ToUint8Array } from './utils';

function PreviewImage() {
  const { t } = useTranslation();
  const {
    setCrop,
    setCompletedCrop,
    setIsOpen,
    uploadAction,
    useUpload,
    setCurrentScreen,
    previewImage,
    setModalProps
  } = useContext(UploadLogoContext);
  const { mutateAsync: uploadAsset, reset, isLoading } = useUpload();

  const uploadHandle = async file => {
    if (Array.isArray(file)) {
      file.forEach(async f => {
        const formData = new FormData();
        formData.set('file', f);
        const response = await uploadAsset(formData);
        uploadAction(response);
      });
    } else {
      const formData = new FormData();
      formData.set('file', file);
      const response = await uploadAsset(formData);
      uploadAction(response);
    }

    setTimeout(() => {
      const primaryButtonOnClick = () => setIsOpen(false);
      const primaryButtonProps = {
        onClick: primaryButtonOnClick
      };
      setCurrentScreen(UPLOAD_LOGO_SCREEN.upload);
      setCrop();
      setCompletedCrop();
      reset();
      setModalProps(props => ({
        ...props,
        primaryButtonProps,
        secondaryButtonProps: {}
      }));
      setIsOpen(false);
    }, 200);
  };

  useEffect(() => {
    const primaryButtonProps = {
      loading: isLoading,
      children: t('submit'),
      onClick: () => {
        const u8Image = b64ToUint8Array(previewImage);
        uploadHandle(new Blob([u8Image], { type: 'image/png' }));
      }
    };
    const secondaryButtonProps = {
      children: t('back'),
      onClick: () => {
        setCurrentScreen(UPLOAD_LOGO_SCREEN.crop);
      }
    };
    setModalProps(props => ({
      ...props,
      primaryButtonProps,
      secondaryButtonProps
    }));
  }, [isLoading]);

  return (
    <S.PreviewWrapper>
      <Typography style={{ maxWidth: 400, textAlign: 'center' }} variant="body1Bold">
        {t('previewLogoAndSubmit')}
      </Typography>
      <S.PreviewCard>
        <Image
          name="merchantLogoWeb"
          alt="Merchant Logo"
          height={30}
          style={{ position: 'absolute', right: 24, top: 24 }}
        />
        <S.PreviewCardInner>
          <Image src={previewImage} alt={t('logo')} height="auto" width="auto" />
          <div>
            <Typography variant="body1">{t('youReceivedGiftFromName')}</Typography>
            <Typography variant="subtitle2Bold" fontFamily="primary">
              ({t('yourNameHere')})
            </Typography>
          </div>
          <S.GiftMessageWrapper>
            <S.GiftMessage>({t('yourGiftMessageHere')})</S.GiftMessage>
          </S.GiftMessageWrapper>
          <S.ButtonGroup>
            <Button
              style={{ backgroundColor: 'var(--color-accent-secondary-default)' }}
              size="lg"
              block
              onClick={() => {}}
            >
              {t('unwrapGift')}
            </Button>
            <S.SkipUnWrapWrapper>
              <Button variant="link" size="lg" block onClick={() => {}}>
                {t('skipUnwrap')}
              </Button>
            </S.SkipUnWrapWrapper>
          </S.ButtonGroup>
        </S.PreviewCardInner>
      </S.PreviewCard>
    </S.PreviewWrapper>
  );
}

export { PreviewImage };
